export default {
  Title      : 'Interest Rate',
  HeaderTitle: 'Interest Rate'
}
